import { CardLoader } from 'components/organisms'
import withLoader from 'hocs/with-loader'
import CheckoutShipment from 'domains/customer-checkout/organisms/shipment'
import PropTypes from 'prop-types'

const CustomerCheckoutShipmentSection = ({
  isLoading,
  shipment,
  handleClickShippingMethod,
  handleClickInsuranceCheckbox,
  selectedShipmentMethod
}) => {

  const CheckoutShipmentList = () => (
    <CheckoutShipment
      shipment={ shipment }
      handleClickShippingMethod={ handleClickShippingMethod }
      handleClickInsuranceCheckbox={ handleClickInsuranceCheckbox }
      selectedShipmentMethod={ selectedShipmentMethod }
    />
  )

  const CheckoutShipmentListWithLoader = withLoader(CheckoutShipmentList,CardLoader)

  return (
    <div className='mb-4'>
      <div className='d-flex justify-content-between align-items-center mb-1'>
        <strong className='text-gray-light'>Shipments</strong>
      </div>
      <CheckoutShipmentListWithLoader isLoading={ isLoading } />
    </div>
  )
}

CustomerCheckoutShipmentSection.propTypes = {
  isLoading                    : PropTypes.bool.isRequired,
  shipment                     : PropTypes.object.isRequired,
  handleClickShippingMethod    : PropTypes.func.isRequired,
  handleClickInsuranceCheckbox : PropTypes.func,
  selectedShipmentMethod       : PropTypes.object
}

CustomerCheckoutShipmentSection.defaultProps = {
  isLoading                 : true,
  shipment                  : {},
  handleClickShippingMethod : () => { alert('handleClickShippingMethod()')}
}

export default CustomerCheckoutShipmentSection